import { render, staticRenderFns } from "./h5ScanPageConfig.vue?vue&type=template&id=6e85c48f&scoped=true"
import script from "./h5ScanPageConfig.vue?vue&type=script&lang=js"
export * from "./h5ScanPageConfig.vue?vue&type=script&lang=js"
import style0 from "./h5ScanPageConfig.vue?vue&type=style&index=0&id=6e85c48f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e85c48f",
  null
  
)

export default component.exports